import { render } from "./SiteFocusDialog.vue?vue&type=template&id=70cddc04&scoped=true"
import script from "./SiteFocusDialog.vue?vue&type=script&lang=js"
export * from "./SiteFocusDialog.vue?vue&type=script&lang=js"

import "./SiteFocusDialog.vue?vue&type=style&index=0&id=70cddc04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cddc04"]])

export default __exports__